import { z } from "zod";

export const BillingActionSchema = z.object({
  enabled: z.boolean(),
  hint: z.string().nullable(),
});

export const BillingSummarySchema = z.object({
  status: z.string(),
  trialEndsAt: z.string().nullable().optional(),
  trialEndsAtDisplay: z.string().nullable().optional(),
  daysUntilTrialEnd: z.number().nullable().optional(),
  trialExpired: z.boolean().optional(),
  restricted: z.boolean().optional(),
  showTrialEndsInUi: z.boolean().optional(),
  hasPaymentMethod: z.boolean().optional(),
  provider: z.string().nullable().optional(),
  providerLabel: z.string().nullable().optional(),
  hasSubscription: z.boolean().optional(),
  hasStripeCustomer: z.boolean().optional(),
  hasStripeSubscription: z.boolean().optional(),
  inFreeTrialWithActiveSubscription: z.boolean().optional(),
  subscriptionCancelAtPeriodEnd: z.boolean().optional(),
  subscriptionPeriodEndAt: z.string().nullable().optional(),
  subscriptionPeriodEndAtDisplay: z.string().nullable().optional(),
  billingActions: z
    .object({
      checkout: BillingActionSchema,
      portal: BillingActionSchema,
    })
    .optional(),
  showWarning: z.boolean().optional(),
});

export const BillingResponseSchema = z.object({
  billing: BillingSummarySchema.nullable(),
  organization: z.unknown().optional(),
});

export type BillingSummary = z.infer<typeof BillingSummarySchema>;
export type BillingResponse = z.infer<typeof BillingResponseSchema>;
